import { render, staticRenderFns } from "./SectionInstructors.vue?vue&type=template&id=4d291c0a&scoped=true"
import script from "./SectionInstructors.vue?vue&type=script&lang=js"
export * from "./SectionInstructors.vue?vue&type=script&lang=js"
import style0 from "./SectionInstructors.vue?vue&type=style&index=0&id=4d291c0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d291c0a",
  null
  
)

export default component.exports